import { getClassifierApiUrl } from '@/lib/runtimeConfig';
/**
 * Live master list from the classifier backend — the same data injected
 * into the AI prompt, so the UI can never drift from the real behaviour.
 */
export async function fetchCategoryMaster() {
    const res = await fetch(`${getClassifierApiUrl()}/api/categories`);
    if (!res.ok) {
        throw new Error(`Categories API ${res.status}`);
    }
    const json = (await res.json());
    return {
        categories: Array.isArray(json.categories)
            ? json.categories.map(String)
            : [],
        keywordMaster: json.keywordMaster && typeof json.keywordMaster === 'object'
            ? Object.fromEntries(Object.entries(json.keywordMaster).map(([k, v]) => [
                k,
                Array.isArray(v) ? v.map(String) : [],
            ]))
            : {},
    };
}
async function mutateKeyword(graphToken, category, keyword, method) {
    const suffix = method === 'DELETE' ? `/${encodeURIComponent(keyword)}` : '';
    const res = await fetch(`${getClassifierApiUrl()}/api/categories/${encodeURIComponent(category)}/keywords${suffix}`, {
        method,
        headers: {
            Authorization: `Bearer ${graphToken}`,
            ...(method === 'POST'
                ? { 'Content-Type': 'application/json' }
                : {}),
        },
        body: method === 'POST' ? JSON.stringify({ keyword }) : undefined,
    });
    const text = await res.text();
    if (!res.ok) {
        try {
            const json = JSON.parse(text);
            throw new Error(json.error || `Keyword API ${res.status}`);
        }
        catch (err) {
            if (err instanceof Error)
                throw err;
            throw new Error(`Keyword API ${res.status}`);
        }
    }
    const json = JSON.parse(text);
    return {
        categories: json.categories || [],
        keywordMaster: json.keywordMaster || {},
    };
}
export function addCategoryKeyword(graphToken, category, keyword) {
    return mutateKeyword(graphToken, category, keyword, 'POST');
}
export function removeCategoryKeyword(graphToken, category, keyword) {
    return mutateKeyword(graphToken, category, keyword, 'DELETE');
}
